module.exports = __webpack_public_path__ + "img/6.935427f2.png";